/**
 * Tiny, failure-tolerant wrapper around localStorage for per-device conveniences
 * (language, theme). Storage can be unavailable (private mode, blocked cookies),
 * so every access is guarded and the app works without it.
 */
const PREFIX = 'shycut:';

export type PreferenceKey =
  | 'language'
  | 'analytics'
  | 'theme'
  | 'privacy-precision'
  | 'caption-language'
  | 'caption-quality'
  | 'caption-gpu-failed'
  | 'export-broken-encoders'
  | 'export-extras'
  | 'last-build'
  | 'presets'
  | 'units'
  | 'places'
  | 'recording-mode'
  | 'recording-microphone'
  | 'recording-microphone-id'
  | 'recording-camera-id'
  | 'recording-system-audio'
  | 'recording-notes'
  | 'recording-notes-speed'
  | 'media-panel'
  | 'media-panel-width';

export function readPreference(key: PreferenceKey): string | null {
  try {
    return globalThis.localStorage?.getItem(PREFIX + key) ?? null;
  } catch {
    return null;
  }
}

/** Stores a preference; null forgets it. */
export function writePreference(key: PreferenceKey, value: string | null): void {
  try {
    if (value === null) globalThis.localStorage?.removeItem(PREFIX + key);
    else globalThis.localStorage?.setItem(PREFIX + key, value);
  } catch {
    // Storage unavailable — the preference simply won't persist.
  }
}
